import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from "../../authentication/authentication.service";
import {EventService} from "./event.service";
import {UtilsService} from "./utils.service";
import * as _ from "lodash";
import { Angulartics2 } from 'angulartics2';
import { ToastrService } from 'ngx-toastr';
import { HybridToolsService } from './hybrid-tools.service';
import {ProgressService} from "./progress.service";

declare var moment: any;

@Injectable()
export class DonationService {
    constructor(
        private http: HttpClient,
        private authService: AuthenticationService,
		private hybridToolsService: HybridToolsService,
		private eventService: EventService,
        private utilsService: UtilsService,
		private angulartics2: Angulartics2,
        private toastr: ToastrService,
		private progressService: ProgressService
    ) {}

    parseData(donationData) {
        var donations = donationData;
        var list = [];
        var totalDonated = 0;
        var numEntries = donations.length;
        for (var i = 0; i < numEntries; i++) {
            var d = donations[i];
            var donation = {
                amount: this.utilsService.to2dp((parseFloat(d.donationAmount)).toFixed(2)),
                status: (d.status == null ? 'Completed' : this.utilsService.ucFirst(d.status)),
                donationType: d.donationType,
                paymentMethod: d.paymentMethod,
                fundType: d.fundType,
                source: this.utilsService.ucFirst(d.fundraiserType),
                donationDate: moment(d.donationDate),
                address: this.utilsService.formatAddress(d),
                fullName: d.donorFirstName + ' ' + d.donorLastName,
                donor: {
                    firstName: d.donorFirstName,
                    lastName: d.donorLastName
                }
            };
            list.push(donation);
            if (donation.status != 'Voided') {
                totalDonated += this.utilsService.to2dp(parseFloat(d.donationAmount));
            }
        }

        return {
            donationList: list
        };
    }

    acceptIndividualDonation(pageName: string): void {
    	this.acceptDonation(this.eventService.selectedEvent.gql.Participant[0].fundraiser);
		this.angulartics2.eventTrack.next({
			action: 'Accept Donation',
			properties: {category: pageName}
		});
    }

	acceptTeamDonation(): void {
		this.acceptDonation(this.eventService.selectedEvent.gql.Participant[0].team.fundraiser);
	}

	private acceptDonation(fundraiser): void {
        if(fundraiser.canAcceptDonations) {
            if (this.hybridToolsService.isMobileOperatingSystem()) {
				this.acceptMobileDonation();
            } else {
				this.acceptDesktopDonation(fundraiser);
            }
        } else {
            this.toastr.error("Fundraiser can't accept donation");
        }
	}

	private acceptDesktopDonation(fundraiser): void {
		var firstName = '';
		var lastName = '';
		var teamUrl = '';
		var displayName = '';
    
		if (fundraiser.fundraiserType.name === 'TEAM') {
			teamUrl = fundraiser.fullUrl;
			displayName = this.eventService.selectedEvent.gql.Participant[0].team.name;
		} else {
			firstName = this.eventService.selectedEvent.gql.Participant[0].individualConstituent.firstName;
			lastName = this.eventService.selectedEvent.gql.Participant[0].individualConstituent.lastName;
			displayName = firstName + ' ' + lastName;
		}

		var fundraiserPageId = fundraiser.fundraiserPageId;
		var fullUrl = fundraiser.fullUrl;

		/* Legacy donation pages (ie SE, S2, SOY, and LCR) lookup the fundraiser by the url.  Since the URL is stored in the
		 * database as 'http://' we have to adjust the link.  Realistically the check in the legacy system should be based upon
		 * the fundraiser id and not the URL
		 */
		 fullUrl = fullUrl.replace('https://', 'http://');

		var programGroup = this.eventService.selectedEvent.gql.Participant[0].event.program.programGroup.name;
		var program = this.eventService.selectedEvent.gql.Participant[0].event.program.name;

		var defaultParams = {
			fundraiserPageID: fundraiserPageId,
			participantFirstName: firstName,
			participantLastName: lastName,
			programGroupName: programGroup,
			displayName: displayName,
			fundraiserPageURL: fullUrl
		}

		var sysEventType = this.eventService.selectedEvent.gql.Participant[0].event.sysEventTypeName;
		var oocpeId = this.eventService.selectedEvent.gql.Participant[0].adoptedEvent.adoptedEventId;

		if (sysEventType === 'EB_STAFF_EVENT') {
			var fundraiserId = fundraiser.fundraiserId;
			var fundraiserPageTemplateType = fundraiser.fundraiserPageTemplateType.name;

			var sysThemeTypeName = this.eventService.selectedEvent.gql.Participant[0].adoptedEvent.sysThemeTypeName;
			var bannerPath = this.eventService.selectedEvent.gql.Participant[0].adoptedEvent.bannerPath;
			var isSinglePage = this.eventService.selectedEvent.gql.Participant[0].adoptedEvent.isSinglePage;
			var pciFundraiserURL = this.eventService.selectedEvent.gql.Participant[0].event.program.programGroup.pciFundraiserUrl;

			var specialEventParams = {
				nextShoppingCartAction: 'checkout',
				fundraiserIDTo: fundraiserId,
				themeName: sysThemeTypeName,
				teamURL: teamUrl,
				oocpe: oocpeId,
				fundraiserPageTemplateType: fundraiserPageTemplateType
			}

			var link = pciFundraiserURL + '/frShoppingCart.action?' + $.param(_.merge(defaultParams, specialEventParams));
			window.open(link, '_blank');

		} else if (sysEventType === 'C360_EVENT') {
			var donateUrl = this.eventService.selectedEvent.gql.Participant[0].event.program.programGroup.donateUrl;

			if (programGroup === 'LTN' || programGroup === 'TNT' || programGroup === 'MWOY') {

				//bah, this should be configured in the database
				if (program === 'SOY') {
					donateUrl = donateUrl.replace('/voy/','/svoy/');
				}

				var link = donateUrl + '?' + $.param(defaultParams);
				window.open(link, '_blank');
			} else if (programGroup === 'REGATTA') {
				var regattaParams = {
					nextShoppingCartAction: 'checkout',
					oocpe: oocpeId
				}
				var link = donateUrl + '?' + $.param(_.merge(defaultParams, regattaParams));
				window.open(link, '_blank');
			} else {
				console.error('Unknown programGroup: ' + programGroup + ' for event type: ' + sysEventType);
			}
		} else {
			console.error('Unknown event type: ' + sysEventType);
		}
	}

	private acceptMobileDonation(): void {
		var participantId = this.eventService.selectedEvent.gql.Participant[0].participantId;
		var programGroup = this.eventService.selectedEvent.gql.Participant[0].event.program.programGroup.name;
		var fundraiserPageId = this.eventService.selectedEvent.gql.Participant[0].fundraiser.fundraiserPageId;
		var allowMobileCheckDonations = this.eventService.selectedEvent.gql.Participant[0].adoptedEvent.allowMobileCheckDonations;
		var allowMobileCreditCardDonations = this.eventService.selectedEvent.gql.Participant[0].adoptedEvent.allowMobileCreditCardDonations;

		var belongsToTeam = false;
		var teamFundraiserPageId;

		//MWOY has teams, but they don't have fundraising pages, all donations goto the participant (and eventually get rolled up)
		if (programGroup !== 'MWOY' && this.eventService.selectedEvent.gql.Participant[0].team) {
			belongsToTeam = true;
			teamFundraiserPageId = this.eventService.selectedEvent.gql.Participant[0].team.fundraiser.fundraiserPageId
		}

		var fundraisingToolsDonationUrl = this.eventService.selectedEvent.gql.Participant[0].event.program.programGroup.mobileDonationUrl;

		var myLLSParams = {
			ocpEventMemberID: participantId,
			programGroupName: programGroup,
			personalFundRaisingPageID: fundraiserPageId,
			teamFundRaisingPageID: teamFundraiserPageId,
			belongsToTeam: belongsToTeam,
			allowCheckDonation: allowMobileCheckDonations,
			allowCreditCardDonation: allowMobileCreditCardDonations,
			devicePlatform: this.hybridToolsService.getOperatingSystem(),
			deviceID: 'Unknown'
		}

		//generally speaking, the call to get the crowd token is pretty fast, but if the db is under load, it may appear
		//to the end user like nothing is happening, so we'll throw up the progress bar
		this.progressService.startProgress(false);

		if (this.hybridToolsService.isMobileApp()) {

			this.authService.getCrowdToken().subscribe(data => {

				this.progressService.stopProgress(false);

				const crowdParams = {
					newAuth: data['crowdToken']
				}

				const link = fundraisingToolsDonationUrl + '?' + $.param(_.merge(myLLSParams, crowdParams));

				this.hybridToolsService.openExternalLink(link);
			});

		} else {
			//open the a blank popup the location will be assigned once we have the token ... this is Used to fix the issue for mobile web app
			const donationWindow = window.open('', '_blank');

			this.authService.getCrowdToken().subscribe(data => {

				this.progressService.stopProgress(false);

				const crowdParams = {
					newAuth: data['crowdToken']
				}

				const link = fundraisingToolsDonationUrl + '?' + $.param(_.merge(myLLSParams, crowdParams));

				donationWindow.location.assign(link);
			});

		}
	}
}
